import { StandardEvents } from '@shopify/events';

/**
 * Keeps the AOMA header's intentionally custom visual shell connected to
 * Horizon's native cart event stream. Cart state remains Shopify-owned; this
 * component only reflects the resolved item count and drawer state.
 */
class AomaCartHeader {
  #root;
  #abortController = new AbortController();

  constructor(root) {
    this.#root = root;
  }

  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate, {
      signal: this.#abortController.signal,
    });

    document.addEventListener('theme-drawer:open', this.#onDrawerStateChange, {
      signal: this.#abortController.signal,
    });
    document.addEventListener('theme-drawer:close', this.#onDrawerStateChange, {
      signal: this.#abortController.signal,
    });

    this.#syncDrawerState();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const itemCount = cart?.totalQuantity ?? detail?.itemCount;
        if (itemCount === undefined) return;
        this.#renderCount(itemCount);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[aoma-cart] Cart update rejected:', error);
      });
  };

  #onDrawerStateChange = (event) => {
    if (event.target?.id === 'cart-drawer') this.#syncDrawerState();
  };

  #syncDrawerState() {
    const drawer = document.getElementById('cart-drawer');
    const trigger = this.#root.querySelector('[data-aoma-cart-trigger]');
    if (!drawer || !trigger) return;
    trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
  }

  #renderCount(itemCount) {
    const count = Math.max(0, Number(itemCount) || 0);
    const countElement = this.#root.querySelector('[data-aoma-cart-count]');
    const trigger = this.#root.querySelector('[data-aoma-cart-trigger]');
    if (!countElement) return;

    countElement.textContent = String(count);
    countElement.classList.toggle('is-hidden', count === 0);
    trigger?.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
  }
}

const header = document.querySelector('.aoma-header-section');
if (header) new AomaCartHeader(header).connectedCallback();
